import * as React from 'react';
import { createUseStyles } from 'react-jss';

import { FieldWrap } from './index';
import { FormError } from '../../interfaces';

const useStyles = createUseStyles({
    input: {
        border: 0,
        backgroundColor: 'white',
        transition: 'background-color .1s ease-in',
        '&[disabled]': {
            backgroundColor: '#dddddd',
            cursor: 'not-allowed'
        }
    }
});

interface TextAreaProps {
    name: string;
    label: string;
    error?: FormError;
    required?: boolean;
    register: (options: object) => any;
    validation?: object;
    disabled?: boolean;
}

const TextArea: React.FC<TextAreaProps> = ({
    name,
    label,
    error,
    register,
    required = false,
    validation,
    disabled = false
}: TextAreaProps) => {
    const classes = useStyles();

    return (
        <FieldWrap label={label} error={error} required={required}>
            <textarea
                name={name}
                className={classes.input}
                disabled={disabled}
                required={required}
                ref={register({ required, ...validation })}
            />
        </FieldWrap>
    );
};

export default React.memo(TextArea);
